import { createContext } from 'react'
// import createActions from './createActions';

export default createContext({})
